import { render, staticRenderFns } from "./classroomDetail.vue?vue&type=template&id=b97af55e&scoped=true"
import script from "./classroomDetail.vue?vue&type=script&lang=js"
export * from "./classroomDetail.vue?vue&type=script&lang=js"
import style0 from "./classroomDetail.vue?vue&type=style&index=0&id=b97af55e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b97af55e",
  null
  
)

export default component.exports